var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 22.0001C21.3977 22.0001 21.9968 21.4111 21.9968 20.6898V7.32518C21.9968 6.60395 21.3977 6.01495 20.6663 6.01495H7.67969L12.8916 22.0001H20.6663Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 6.61597C20.8607 6.61597 21.045 6.6921 21.1833 6.82833C21.3195 6.96256 21.3957 7.13886 21.3957 7.32518V20.6898C21.3957 20.8762 21.3216 21.0525 21.1833 21.1867C21.045 21.3229 20.8607 21.399 20.6663 21.399H13.3284L8.50726 6.61597H20.6663ZM20.6663 6.01495H7.67969L12.8916 22.0001H20.6663C21.3977 22.0001 21.9968 21.4111 21.9968 20.6898V7.32518C21.9968 6.60395 21.3977 6.01495 20.6663 6.01495Z",
    fill: "#DCDCDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 18.2235L12.8944 21.9999L16.3149 18.2235H11.6641Z",
    fill: "#4352B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7578 11.5381V10.7548H16.9806V9.48862H15.7543V10.7548H13.3438V11.5381H18.1408C17.8844 12.4416 17.3173 13.2951 16.7642 13.9582C15.7844 12.7982 15.7804 12.4216 15.7804 12.4216H14.7624C14.7624 12.4216 14.8045 12.9865 16.1791 14.5973C15.7323 15.0541 15.3936 15.3245 15.3936 15.3245L15.7062 16.3022C15.7062 16.3022 16.1791 15.8955 16.7702 15.2684C17.3634 15.9115 18.1288 16.6848 19.1187 17.6064L19.7619 16.9633C18.7019 16.0017 17.9244 15.2384 17.3534 14.6253C18.1188 13.7198 18.8963 12.5799 19.0606 11.5361H20.7558V11.5381H20.7578Z",
    fill: "#607988"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33052 2C2.59914 2 2 2.59902 2 3.33226V16.8953C2 17.6265 2.59914 18.2255 3.33052 18.2255H16.3171L11.1053 2H3.33052Z",
    fill: "#4285F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 6.01495H20.6662C21.3976 6.01495 21.9967 6.60395 21.9967 7.32518V15.3428L12.7031 6.01495Z",
    fill: "url(#paint0_linear_2105_161524)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44357 10.6267C9.39348 11.2337 8.8745 12.1332 7.61811 12.1332C6.53005 12.1332 5.64838 11.2337 5.64838 10.1258C5.64838 9.01796 6.53005 8.11843 7.61811 8.11843C8.23729 8.11843 8.65007 8.38689 8.88652 8.60526L9.71208 7.81191C9.16905 7.31107 8.46171 6.99854 7.61811 6.99854C5.89284 6.99854 4.49219 8.39891 4.49219 10.1238C4.49219 11.8488 5.89284 13.2491 7.61811 13.2491C9.42554 13.2491 10.6198 11.981 10.6198 10.192C10.6198 9.93552 10.5877 9.7472 10.5457 9.55487H7.62012V10.6247L9.44357 10.6267Z",
    fill: "#EEEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6694 6.01481H12.3957L11.1053 2H3.33052C2.59914 2 2 2.59902 2 3.33226V16.8953C2 17.6265 2.59914 18.2255 3.33052 18.2255H11.6643L12.8947 21.9999H20.6694C21.4008 21.9999 21.9999 21.4109 21.9999 20.6897V7.32503C21.9999 6.60381 21.4008 6.01481 20.6694 6.01481Z",
    fill: "url(#paint1_radial_2105_161524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2105_161524",
    x1: 12.7031,
    y1: 10.6789,
    x2: 21.9967,
    y2: 10.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2105_161524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.30664 2.38798) scale(28.0185 28.0129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTranslate);
export default __webpack_public_path__ + "static/media/Google_Translate.449a3b508ee2574d62060aa2bbc4fa08.svg";
export { ForwardRef as ReactComponent };